import useConnector from './useConnector';
export { ConnectorProvider } from './useConnector';

export default useConnector;
